import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { StaticDataService } from './static-data.service';
declare var ga;
@Injectable()
export class GoogleAnalyticsService {
  constructor( private router: Router) {
  }

  gaPageView(){
    //this function will call first from app.component.ts
    //when every time navigation will change it will call
    this.router.events.subscribe(event => {
      let userName=localStorage.getItem(StaticDataService.tokenLiteral);
      //check whether token is present or not
      if(!!userName) userName=JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['name']
      let tenantName=sessionStorage.getItem(StaticDataService.tenantName);
      if(!!tenantName && !!userName){
        if (event instanceof NavigationEnd) {
          ga('config', environment.gaKey);
          ga('set', 'page', event.url);
          ga('send', 'pageview',{
            'dimension2': `${userName}`,
            'dimension1': `${tenantName}`
          });
        }
      }else{
        // console.error('TenantName Null',window.location.href)
      }


    });
  }

  gaEventView(eventCategory:string, eventAction:string,
    eventLabel:string,eventValue: number = 0){
      if(JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)) &&
      JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).name &&
      sessionStorage.getItem(StaticDataService.tenantName) ){
      let userName=JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).name;
      let tenantName=sessionStorage.getItem(StaticDataService.tenantName);
      if(!!tenantName && !!userName){
        ga('send', 'event', {
          eventCategory: eventCategory,
          eventLabel: eventLabel==''?window.location.href:eventLabel,
          eventAction: eventAction,
          eventValue: eventValue,
          'dimension2': `${userName}`,
          'dimension1': `${tenantName}`
        });
      }
    }else{
        // console.error('TenantName Null',window.location.href)
      }
 
  }
}
